import "core-js/modules/es6.array.filter";
import React from 'react';
import bem from '../../_utils/bem';
import Heading from '../../01-atoms/text/Heading.component';

var Grid = function Grid(_ref) {
  var gridLabel = _ref.gridLabel,
      children = _ref.children,
      _ref$block = _ref.block,
      block = _ref$block === void 0 ? 'grid' : _ref$block,
      element = _ref.element,
      _ref$modifiers = _ref.modifiers,
      modifiers = _ref$modifiers === void 0 ? [] : _ref$modifiers,
      gridType = _ref.gridType,
      _ref$pageLayoutModifi = _ref.pageLayoutModifier,
      pageLayoutModifier = _ref$pageLayoutModifi === void 0 ? 'contained' : _ref$pageLayoutModifi;
  var mods = [].concat(modifiers, gridType, pageLayoutModifier).filter(function (item) {
    return item;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Heading, {
    level: 2
  }, gridLabel), /*#__PURE__*/React.createElement("div", {
    className: bem(block, element, mods)
  }, children));
};

export default Grid;